module.exports = __webpack_public_path__ + "static/media/lock_command.44d67ebf.svg";